import type { TFunction } from 'i18next';
import { MoreHorizontal, Trash2 } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import type { Member } from '../types';

interface ClientMemberRowActionsProps {
  member: Member;
  onDelete: (memberId: string) => void;
  isLoading?: (memberId: string) => boolean;
  t: TFunction;
}

export function ClientMemberRowActions({
  member,
  onDelete,
  isLoading,
  t,
}: ClientMemberRowActionsProps) {
  const isDeleting = isLoading?.(member.id);

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button
              size="icon"
              variant="ghost"
              disabled={isDeleting}
              className="h-7 w-7 opacity-0 group-hover:opacity-100 data-[state=open]:opacity-100 transition-opacity"
              aria-label={t('actions.openMenu')}
              data-testid={`client-members-row-actions-${member.id}`}
            >
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent>{t('actions.openMenu')}</TooltipContent>
      </Tooltip>

      <DropdownMenuContent align="end">
        <DropdownMenuItem
          disabled={isDeleting}
          onClick={() => onDelete(member.id)}
          className="text-destructive focus:text-destructive focus:bg-destructive/10"
        >
          <Trash2 className="w-4 h-4" />
          {t('actions.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
